<script setup lang="ts">
import { CircleHelp } from '@lucide/vue';
import {
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from 'reka-ui';

defineProps<{ label: string }>();
</script>

<template>
  <TooltipProvider :delay-duration="200">
    <TooltipRoot>
      <TooltipTrigger as-child>
        <button type="button" class="hint-trigger" :aria-label="label">
          <CircleHelp :size="14" />
        </button>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent side="top" :side-offset="6" class="hint-bubble">
          <slot />
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>
